import React from "react";
import styles from "./notificationModal.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

type Props = {
  color: string;
  icon_class?: IconProp;
  message: string;
  img_src?: string;
  type?: string;
};
const NotificationModal: React.FC<Props> = ({
  color,
  icon_class,
  message,
  img_src,
  type,
}) => {
  return (
    <div
      className={
        type === "contact"
          ? `${styles["notificationModal"]} ${styles["changed"]}`
          : img_src
          ? `${styles["notificationModal"]} ${styles["save"]}`
          : `${styles["notificationModal"]} ${styles["changed"]}`
      }
      style={{ backgroundColor: color }}
    >
      {img_src ? (
        <div className={styles["notificationModal__imgBox"]}>
          <img src={img_src} />
        </div>
      ) : null}
      <div className={styles["notificationModal__messageBox"]}>
        {icon_class ? (
          <div className={styles["notificationModal__messageBox__icon"]}>
            <FontAwesomeIcon icon={icon_class} />
          </div>
        ) : null}
        <span className={styles["notificationModal__messageBox__message"]}>
          {message}
        </span>
      </div>
    </div>
  );
};

export default NotificationModal;
